import React, { useEffect } from "react";
import { observer, inject } from "mobx-react";
import MaterialTable, { MTableToolbar } from "material-table";
import {
  UnmatchedAccountsColumns,
  qarManagersOptions,
} from "../../helper/constants";
import QarResponsibleManager from "./QarResponsibleManager";
import Grid from "@material-ui/core/Grid";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { Typography, IconButton } from '@material-ui/core';
import { QARFormStore } from "../../stores/qarFormStore";
import { HtmlTooltip } from "../HtmlTooltip/HtmlTooltip";
import {exportTableToExcel} from "../../helper/fileExtensions";

const QarUnmatchedAccounts = inject("RootStore")(
  observer(({ RootStore, props }) => {
    useEffect(() => {
      RootStore.qarStore.getAllManagers();
      RootStore.qarStore.getUnmatchedAccounts(
        RootStore.qarStore.currentlySelectedAccountForReview.id
      );
      RootStore.accountStore.getUpdatedDateBySelectedAccount();
    }, []);

    const tableName = `${RootStore.qarStore.currentlyReviewedSystemForReview.name} / ${RootStore.qarStore.currentlySelectedAccountForReview.name} / Not Recognized Accounts`;

    const tableOptions = {
        ...qarManagersOptions, exportCsv: (columns, data) => {
            let managers = RootStore.qarStore.allManagers.map((option) => ({
                id: option.id,
                firstName: option.firstName,
                secondName: option.secondName,
                surname: option.surname,
            }));
            let exportData = JSON.parse(JSON.stringify(data));
            exportData.forEach((rowData) => {
                let currentManager = managers.find(m => m.id === rowData.responsibleManagerId);
                rowData.firstName = [rowData.firstName, rowData.lastName].filter(e => e).join(' ');
                rowData.responsibleManagerId = currentManager ?
                    [currentManager.firstName, currentManager.secondName, currentManager.surname]
                        .filter(e => e).join(' ') : '';
            });
            exportTableToExcel(columns, exportData);
        }
    }

    return (
      <MaterialTable
        title=""
        data={RootStore.qarStore.unmatchedAccounts}
        options={tableOptions}
        columns={[
          ...UnmatchedAccountsColumns,
          {
            title: "Set responsible manager",
            field: "responsibleManagerId",
            align: "center",
            width: "100%",
            render: (rowData) => (
              <QarResponsibleManager accountData={rowData} />
            ),
            customSort: (a, b) => a.responsibleManager?.names.localeCompare(b.responsibleManager?.names),
            customFilterAndSearch: (term, rowData) => {
              return rowData.responsibleManager?.names.toLowerCase().indexOf(term.toLowerCase()) !== -1;
            }
          },
        ]}
        components={{
          Toolbar: (tableProps) => (
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={3}
            >
              <Grid item sm={3}>
                <h4 style={{ marginLeft: '10px' }}>
                  {tableName}
                </h4>
              </Grid>
              <Grid item sm={4} style={{ textAlign: 'right' }}>
              {RootStore.accountStore.selectedAccountLastUpdatedDate ?
                <><h4>{new Date(RootStore.accountStore.selectedAccountLastUpdatedDate).toUTCString()}</h4>
                ({new Date(RootStore.accountStore.selectedAccountLastUpdatedDate).toLocaleString()} local time)</> 
                : <></>}
              </Grid>
              <HtmlTooltip
                title={
                  <React.Fragment>
                    <Typography color="inherit" variant="caption">
                      This is the selected system's last successful update date.
                    </Typography>
                  </React.Fragment>
                }
              >
                <IconButton aria-label="delete" size="small">
                  <HelpOutlineIcon fontSize="inherit" />
                </IconButton>
              </HtmlTooltip>
              <Grid item sm={4} style={{ textAlign: 'left' }}>
                <MTableToolbar {...tableProps} />
              </Grid>
            </Grid>
          )
        }}
      />
    );
  })
);

export default QarUnmatchedAccounts;
